export default __webpack_public_path__ + "static/media/1032.4c7ce72c.png";